import storage from 'services/storage'
import {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import {
    useGetChoreographersNamesQuery,
    useI18n,
    useSignupMutation,
} from 'store/Store'

const useRegister = () => {
    const {i18n} = useI18n()
    const {data: choreographersNames} = useGetChoreographersNamesQuery()
    const [errorMessage, setErrorMessage] = useState(null)

    const [doSignup, {error: signupError, data: signupResponse, isLoading}] =
        useSignupMutation()

    const {
        watch,
        handleSubmit,
        unregister,
        control: formControl,
        formState: {errors: formErrors},
        getValues: getFormValues,
        setValue: setFormValue,
    } = useForm()

    const isRegisterInMarkid = watch('isMarkid')
    const onSubmit = async (submittedData) => {
        const {password, confirmPassword, rememberMe} = submittedData
        if (password !== confirmPassword) {
            setErrorMessage(translate('noMatch'))
            return
        }
        setErrorMessage(null)
        storage.setRememberMe(rememberMe || false)
        await doSignup(submittedData)
    }

    const submit = handleSubmit(onSubmit)
    const translate = (label) => i18n.t('welcome.' + label)
    const successMessage = signupResponse?.message

    useEffect(() => {
        setErrorMessage(
            signupError?.data?.message || signupError?.data?.message?.message
        )
        if (!isRegisterInMarkid) {
            unregister('markidName')
        } else {
            unregister('email')
        }
    }, [signupError, isRegisterInMarkid, unregister])

    return {
        formControl,
        submit,
        isLoading,
        signupError,
        errorMessage,
        formErrors,
        getFormValues,
        setFormValue,
        signupResponse,
        successMessage,
        translate,
        choreographersNames,
        isRegisterInMarkid,
    }
}

export default useRegister
